const BLOG_READ_POSTS_STORAGE_KEY = 'cchi-kung:blog-read-posts';

export const getReadBlogPostIds = () => {
    if (typeof window === 'undefined') {
        return [];
    }

    try {
        const storedValue = window.localStorage.getItem(BLOG_READ_POSTS_STORAGE_KEY);
        const parsedValue = storedValue ? JSON.parse(storedValue) : [];

        return Array.isArray(parsedValue) ? parsedValue : [];
    } catch (error) {
        console.warn('Failed to read blog post state from localStorage:', error);
        return [];
    }
};

export const markBlogPostAsRead = (postId) => {
    if (typeof window === 'undefined' || !postId) {
        return;
    }

    try {
        const readPostIds = new Set(getReadBlogPostIds());
        readPostIds.add(postId);
        window.localStorage.setItem(BLOG_READ_POSTS_STORAGE_KEY, JSON.stringify([...readPostIds]));
    } catch (error) {
        console.warn('Failed to save blog post state to localStorage:', error);
    }
};
